import { useNavigate } from 'react-router-dom';
import { AdvertisingCatalogPage } from '../../../ui/advertising/AdvertisingCatalogPage/AdvertisingCatalogPage';
import { AdvertisingProducts } from '../../../ui/advertising/AdvertisingProducts/AdvertisingProducts';
import { useIsAdvertisingProductsCatalogEnabled } from '../../../utils/useIsAdvertisingProductsCatalogEnabled';
import { useTranslation } from '../../../utils/useTranslation';
import { useCpaProducts } from './hooks/useCpaProducts';

export const AdvertisingCatalogProducts: React.FC<{}> = () => {
    const navigate = useNavigate();
    const productsEnabled = useIsAdvertisingProductsCatalogEnabled();

    const t = useTranslation();

    const {
        recomendations,
        isLoadingRecomendations,
        products,
        isLoadingProducts,
        productsSuggest,
        text,
        isSearchMode,
        onChangeText,
        onApplySuggest,
    } = useCpaProducts();

    if (!productsEnabled) {
        navigate('/');
    }

    return (
        <AdvertisingCatalogPage
            title={t('Товары из каталога')}
            titleContent={isSearchMode ? t('Результаты поиска') : t('Рекомендуемые товары')}
            searchPlaceholder={t('Поиск товара')}
            searchValue={text}
            searchSuggest={productsSuggest}
            onApplySearchSuggest={onApplySuggest}
            onChangeSearchInput={onChangeText}
            key={isSearchMode ? 'search' : 'recomendations'}
        >
            <AdvertisingProducts
                products={isSearchMode ? products : recomendations}
                isLoading={products ? isLoadingProducts : isLoadingRecomendations}
            />
        </AdvertisingCatalogPage>
    );
};
